import React from 'react';
import Page from './Page';
import ShortForm from './ShortForm';
//import {TextField} from 'material-ui';
import LiveExperiment from './LiveExperiment';

export default class TakeExperiment extends Page {

	static get mustBeParticipant(){ return true; }

	constructor(...args){
		super(...args);
		this.app.takeExperimentForm.experiment = null;
	}

	componentDidMount(){
		this.app.takeExperimentForm.load({experimentId: this.experimentId});
	}

	componentWillUnmount(){
		this.app.takeExperimentForm.experiment = null;
	}

	get experimentId(){
		return this.props.match.params.id;
	}

	render(){

		const experiment = this.app.takeExperimentForm.experiment;

		const label = experiment ? experiment.name : 'Loading Experiment';

		return (
			<ShortForm 
				label={ label }
				formWidth="large"
				waiting={this.app.takeExperimentForm.loading}
				headerLink={{to:'/experiments', label:'Cancel'}}
			>
				<style>
					{`.header{display:none;}`}
				</style>

				{!!experiment &&
					<LiveExperiment app={this.app} experimentData={experiment.definition} />
				}



			</ShortForm>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/TakeExperiment.js